import React from 'react';
import moment from 'moment';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { getStatusConfig } from './ShipmentStatusBadge';

export default function ShipmentTimeline({ timeline = [] }) {
    if (!timeline || timeline.length === 0) {
        return (
            <div className="text-center p-3 text-muted">
                No activity recorded yet.
            </div>
        );
    }

    // Sort by descending date
    const sorted = [...timeline].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

    return (
        <Scrollbars autoHeight autoHeightMin={150} autoHeightMax={380}>
            <div className="timeline-container px-2">
                {sorted.map((act, index) => {
                    // Extract styles matching status if mapped, otherwise default brand color
                    const config = getStatusConfig(act.status || act.subStatus);
                    
                    return (
                        <div key={act._id || index} className="timeline-item">
                            <div className="timeline-marker" style={{ borderColor: config.color }} />
                            <div className="timeline-content">
                                <div 
                                    className="timeline-action-badge fw-bold" 
                                    style={{ background: config.bg, color: config.color, textTransform: 'uppercase', fontSize: '10px' }}
                                >
                                    {act.subStatus?.replace(/_/g, ' ') || act.status}
                                </div>
                                <h6 className="mb-1 text-dark" style={{ fontSize: '13px' }}>
                                    {act.note || `Status updated`}
                                </h6>
                                <div className="timeline-date d-flex align-items-center gap-1 text-muted" style={{ fontSize: '11px' }}>
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" />
                                    </svg>
                                    {moment(act.timestamp).format("MMM D, YYYY [at] HH:mm")}
                                    {act.performedByName && (
                                        <span className="ms-1 fst-italic">— by {act.performedByName}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </Scrollbars>
    );
}
